<div class="reason">
  <div class="reason-wrap">
    <h2 [innerHTML]="'REASON.TITLE' | translate" class="reason-title"></h2>
    <div class="reason-content">
      <div class="reason-block">
        <div class="reason-icon">
          <img alt="icon" src="/assets/images/landing/icons/icon-reason1.png"/>
        </div>
        <div class="reason-inner">
          <h3 class="reason-subtitle">
            {{ 'REASON.STEP1.LABEL' | translate }}
          </h3>
          <p class="reason-info">{{ 'REASON.STEP1.INFO' | translate }}</p>
        </div>
      </div>
      <div class="reason-block">
        <div class="reason-icon">
          <img alt="icon" src="/assets/images/landing/icons/icon-reason2.png"/>
        </div>
        <div class="reason-inner">
          <h3 class="reason-subtitle">
            {{ 'REASON.STEP2.LABEL' | translate }}
          </h3>
          <p class="reason-info">{{ 'REASON.STEP2.INFO' | translate }}</p>
        </div>
      </div>
      <div class="reason-block">
        <div class="reason-icon">
          <img alt="icon" src="/assets/images/landing/icons/icon-reason3.png"/>
        </div>
        <div class="reason-inner">
          <h3 class="reason-subtitle">
            {{ 'REASON.STEP3.LABEL' | translate }}
          </h3>
          <p class="reason-info">{{ 'REASON.STEP3.INFO' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
